import { FileDoneOutlined, DownloadOutlined, FieldNumberOutlined, MedicineBoxOutlined } from '@ant-design/icons';
import { Row, Col, Select, Button, Tabs, Card, Spin } from 'antd';
import { payoutSelectors } from 'containers/App/selectors';
import { Formik } from 'formik';
import { Form, Input } from 'formik-antd';
import { FC } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { exportFile } from 'utils/export.api';
import { HeaderTitle, Pagination } from 'components';
import TableDeposit from './TableDeposit';
import { resetData, startLoading } from './slice';
import { Wrap } from './styles';
import { filterBill, getDataExport, getOptionYear, searchBill } from './thunk';

const initialValues = {
  facility_code: '',
  facility_name: '',
  account_name: '',
};

const monthDefault =
  new Date().getMonth() > 0 && new Date().getMonth() < 10
    ? '0' + new Date().getMonth()
    : new Date().getMonth() === 0
    ? '12'
    : new Date().getMonth().toString();

const yearDefault = (new Date().getFullYear() - (new Date().getMonth() === 0 ? 1 : 0)).toString();

const formatter = new Intl.NumberFormat('ja-JP', {
  style: 'currency',
  currency: 'JPY',
});

const { TabPane } = Tabs;
const DepositManagement: FC = () => {
  const dispatch = useDispatch();
  const { optionInvoice, loadE1, itemInvoices, paymentAdded, paymentNoAdd } = useSelector(payoutSelectors);
  const [searchInvoice, setSearchInvoice] = useState({
    year: yearDefault,
    month: monthDefault,
  });
  const [searchValue, setSearchValue] = useState(initialValues);
  const [keyActive, setKeyActive] = useState<string>('振替');
  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    dispatch(getOptionYear());
    return () => {
      dispatch(resetData());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(startLoading());
    dispatch(
      searchBill({
        invoice_month: `${yearDefault}${monthDefault}`,
        payment_method: '振替',
      }),
    );
  }, [dispatch]);

  const searchBillFirst = async () => {
    dispatch(startLoading());
    await dispatch(
      searchBill({
        invoice_month: `${searchInvoice.year}${searchInvoice.month}`,
        payment_method: keyActive,
      }),
    );
    if (!Object.values(searchValue).every((v) => !v) || page > 1) {
      dispatch(startLoading());
      dispatch(
        filterBill({
          ...searchValue,
          invoice_month: `${searchInvoice.year}${searchInvoice.month}`,
          payment_method: keyActive,
          page: page,
        }),
      );
    }
  };

  const AfterUpdateBill = useCallback(() => {
    dispatch(
      filterBill({
        ...searchValue,
        invoice_month: `${searchInvoice.year}${searchInvoice.month}`,
        payment_method: keyActive,
        page: page,
      }),
    );
  }, [searchInvoice, keyActive, page, searchValue, dispatch]);

  const onChangePage = (page: number) => {
    setPage(page);
    dispatch(
      filterBill({
        ...searchValue,
        invoice_month: `${searchInvoice.year}${searchInvoice.month}`,
        payment_method: keyActive,
        page: page,
      }),
    );
  };

  const changeTab = (key: string) => {
    setSearchValue(initialValues);
    setPage(1);
    setKeyActive(key);
    dispatch(
      searchBill({
        invoice_month: `${searchInvoice.year}${searchInvoice.month}`,
        payment_method: key,
      }),
    );
  };

  const handleSubmit = (value: any) => {
    setSearchValue(value);
    dispatch(
      filterBill({
        ...value,
        invoice_month: `${searchInvoice.year}${searchInvoice.month}`,
        payment_method: keyActive,
        page: 1,
      }),
    );
  };
  const handleReset = () => {
    setSearchValue(initialValues);
    dispatch(
      filterBill({
        invoice_month: `${searchInvoice.year}${searchInvoice.month}`,
        payment_method: keyActive,
        page: 1,
      }),
    );
  };

  const exportExcel = useCallback(async () => {
    const result: any = await dispatch(getDataExport(searchInvoice));
    exportFile(
      result.payload,
      'xlsx',
      'InvoiceExcel',
      `入金リスト_${searchInvoice.year}年${Number(searchInvoice.month)}月`,
    );
  }, [dispatch, searchInvoice]);

  return (
    <Wrap>
      <HeaderTitle title="入金処理" icon={FileDoneOutlined} />
      <div className="section">
        <Row className="choose-time">
          <Col style={{ marginLeft: 25 }} span={2} className="extraLargeFont">
            請求月
          </Col>
          <Col span={4}>
            {' '}
            <Select
              className="standardBoldFont"
              value={searchInvoice.year}
              onChange={(e) => setSearchInvoice((oldState) => ({ ...oldState, year: e }))}
              size={'large'}
              defaultValue="2021"
              style={{ width: 133 }}
            >
              {optionInvoice.map((v, i) => (
                <Select.Option key={i} value={v}>
                  {v}
                </Select.Option>
              ))}
            </Select>
            <label htmlFor="year"> 年</label>
          </Col>
          <Col span={3}>
            <Select
              className="standardBoldFont"
              value={searchInvoice.month}
              onChange={(e) => setSearchInvoice((oldState) => ({ ...oldState, month: e }))}
              size={'large'}
              style={{ width: 71 }}
            >
              {month.map((v, i) => (
                <Select.Option key={i} value={v}>
                  {Number(v)}
                </Select.Option>
              ))}
            </Select>
            <label htmlFor="month"> 月度</label>
          </Col>
          <Col span={11}>
            <Button onClick={searchBillFirst} className="btn-change standardBoldFont" size={'large'}>
              変更
            </Button>
          </Col>
          <Col span={3}>
            <Button onClick={exportExcel} className="btn-money-output">
              <DownloadOutlined /> 入金リスト出力
            </Button>
          </Col>
        </Row>
      </div>
      <Spin size="large" spinning={loadE1}>
        <Row>
          <Col style={{ marginTop: '-63px' }} span={24}>
            <Tabs defaultActiveKey="振替" activeKey={keyActive} onTabClick={changeTab} type="card" size={'small'}>
              <TabPane tab="振替" key="振替">
                <div className="mgt-13">
                  {' '}
                  <Row className="dl">
                    <Col span={7}>
                      <Card className="w-card w-card-direct w-bg-ec smallBoldFont" title="口座振替入金合計">
                        <div className="money-info">¥{formatter.format(paymentAdded).substring(1)}</div>
                      </Card>
                    </Col>
                    <Col span={5}>
                      <Card className="w-card w-card-debt w-bg-gr smallBoldFont" title="未入金件数">
                        <div className="money-info">{formatter.format(paymentNoAdd).substring(1)}件</div>
                      </Card>
                    </Col>
                  </Row>
                  <Row className="form-search">
                    <Formik
                      onSubmit={handleSubmit}
                      initialValues={searchValue}
                      render={() => (
                        <Form>
                          <Row className="detail">
                            <Form name="form-search" layout="inline">
                              <label className="label-input standardBoldFont" htmlFor="facility_code">
                                <FieldNumberOutlined
                                  style={{
                                    width: '14px',
                                    marginRight: 5,
                                    fontSize: '16px',
                                    fontWeight: 700,
                                  }}
                                />{' '}
                                取引先番号
                              </label>
                              <Form.Item name="facility_code">
                                <Input
                                  size={'large'}
                                  value={searchValue.facility_code}
                                  onChange={(e) =>
                                    setSearchValue((oldState) => ({ ...oldState, facility_code: e.target.value }))
                                  }
                                  name="facility_code"
                                  style={{ width: 228 }}
                                  id="search-stk"
                                />
                              </Form.Item>
                              <label className="label-input standardBoldFont" htmlFor="search-cs">
                                <MedicineBoxOutlined style={{ marginRight: 5 }} /> 医療機関名
                              </label>
                              <Form.Item name="facility_name">
                                <Input
                                  name="facility_name"
                                  value={searchValue.facility_name}
                                  onChange={(e) =>
                                    setSearchValue((oldState) => ({ ...oldState, facility_name: e.target.value }))
                                  }
                                  id="search-cs"
                                  size={'large'}
                                  style={{ width: 228 }}
                                />
                              </Form.Item>
                              <Form.Item name="btn-back">
                                <Button
                                  htmlType="reset"
                                  onClick={handleReset}
                                  className="btn-backSetup standardBoldFont"
                                  size={'large'}
                                >
                                  リセット
                                </Button>
                              </Form.Item>
                              <Form.Item name="btn-narrow-down-display">
                                <Button
                                  htmlType="submit"
                                  className="btn-narrow-down-display standardBoldFont"
                                  size={'large'}
                                >
                                  絞り込み表示
                                </Button>
                              </Form.Item>
                              <Col style={{ display: 'flex' }} span={24}>
                                <label
                                  style={{ marginLeft: '3rem' }}
                                  className="label-input standardBoldFont"
                                  htmlFor="search-cs"
                                >
                                  入金名
                                </label>
                                <Form.Item name="account_name">
                                  <Input
                                    name="account_name"
                                    value={searchValue.account_name}
                                    onChange={(e) =>
                                      setSearchValue((oldState) => ({ ...oldState, account_name: e.target.value }))
                                    }
                                    id="search-cs"
                                    size={'large'}
                                    style={{ width: 228 }}
                                  />
                                </Form.Item>
                              </Col>
                            </Form>
                          </Row>
                        </Form>
                      )}
                    />
                  </Row>
                  <Row>
                    <Col span={23}>
                      <Pagination
                        page={page}
                        per_page={20}
                        totalItems={itemInvoices.totalItems}
                        onChangePage={onChangePage}
                      />
                    </Col>
                  </Row>
                  <div className="table">
                    <TableDeposit dataSource={itemInvoices.items} afterUpdate={AfterUpdateBill} />
                  </div>
                </div>
              </TabPane>
              <TabPane tab="振込" key="振込">
                <div className="mgt-13">
                  {' '}
                  <Row className="dl">
                    <Col span={7}>
                      <Card className="w-card w-card-direct w-bg-ec smallBoldFont" title="振込入金合計">
                        <div className="money-info">¥{formatter.format(paymentAdded).substring(1)}</div>
                      </Card>
                    </Col>
                    <Col span={5}>
                      <Card className="w-card w-card-debt w-bg-gr smallBoldFont" title="未入金件数">
                        <div className="money-info">{formatter.format(paymentNoAdd).substring(1)}件</div>
                      </Card>
                    </Col>
                  </Row>
                  <Row className="form-search">
                    <Formik
                      onSubmit={handleSubmit}
                      initialValues={searchValue}
                      render={() => (
                        <Form>
                          <Row className="detail">
                            <Form name="form-search" layout="inline">
                              <label className="label-input standardBoldFont" htmlFor="facility_code">
                                <FieldNumberOutlined
                                  style={{
                                    width: '14px',
                                    marginRight: 5,
                                    fontSize: '16px',
                                    fontWeight: 700,
                                  }}
                                />{' '}
                                取引先番号
                              </label>
                              <Form.Item name="facility_code">
                                <Input
                                  size={'large'}
                                  value={searchValue.facility_code}
                                  onChange={(e) =>
                                    setSearchValue((oldState) => ({ ...oldState, facility_code: e.target.value }))
                                  }
                                  name="facility_code"
                                  style={{ width: 228 }}
                                  id="search-stk"
                                />
                              </Form.Item>
                              <label className="label-input standardBoldFont" htmlFor="search-cs">
                                <MedicineBoxOutlined style={{ marginRight: 5 }} /> 医療機関名
                              </label>
                              <Form.Item name="facility_name">
                                <Input
                                  name="facility_name"
                                  value={searchValue.facility_name}
                                  onChange={(e) =>
                                    setSearchValue((oldState) => ({ ...oldState, facility_name: e.target.value }))
                                  }
                                  id="search-cs"
                                  size={'large'}
                                  style={{ width: 228 }}
                                />
                              </Form.Item>
                              <Form.Item name="btn-back">
                                <Button
                                  htmlType="reset"
                                  onClick={handleReset}
                                  className="btn-backSetup standardBoldFont"
                                  size={'large'}
                                >
                                  リセット
                                </Button>
                              </Form.Item>
                              <Form.Item name="btn-narrow-down-display">
                                <Button
                                  htmlType="submit"
                                  className="btn-narrow-down-display standardBoldFont"
                                  size={'large'}
                                >
                                  絞り込み表示
                                </Button>
                              </Form.Item>
                              <Col style={{ display: 'flex' }} span={24}>
                                <label
                                  style={{ marginLeft: '3rem' }}
                                  className="label-input standardBoldFont"
                                  htmlFor="search-cs"
                                >
                                  入金名
                                </label>
                                <Form.Item name="account_name">
                                  <Input
                                    name="account_name"
                                    value={searchValue.account_name}
                                    onChange={(e) =>
                                      setSearchValue((oldState) => ({ ...oldState, account_name: e.target.value }))
                                    }
                                    id="search-cs"
                                    size={'large'}
                                    style={{ width: 228 }}
                                  />
                                </Form.Item>
                              </Col>
                            </Form>
                          </Row>
                        </Form>
                      )}
                    />
                  </Row>
                  <Row>
                    <Col span={23}>
                      <Pagination
                        page={page}
                        per_page={20}
                        totalItems={itemInvoices.totalItems}
                        onChangePage={onChangePage}
                      />
                    </Col>
                  </Row>
                  <div className="table">
                    <TableDeposit dataSource={itemInvoices.items} tab="振込" afterUpdate={AfterUpdateBill} />
                  </div>
                </div>
              </TabPane>
              <TabPane tab="カード" key="カード">
                <div className="mgt-13">
                  {' '}
                  <Row className="dl">
                    <Col span={7}>
                      <Card className="w-card w-card-direct w-bg-ec smallBoldFont" title="カード払い入金合計">
                        <div className="money-info">¥{formatter.format(paymentAdded).substring(1)}</div>
                      </Card>
                    </Col>
                    <Col span={5}>
                      <Card className="w-card w-card-debt w-bg-gr smallBoldFont" title="未入金件数">
                        <div className="money-info">{formatter.format(paymentNoAdd).substring(1)}件</div>
                      </Card>
                    </Col>
                  </Row>
                  <Row className="form-search">
                    <Formik
                      onSubmit={handleSubmit}
                      initialValues={searchValue}
                      render={() => (
                        <Form>
                          <Row className="detail">
                            <Form name="form-search" layout="inline">
                              <label className="label-input standardBoldFont" htmlFor="facility_code">
                                <FieldNumberOutlined
                                  style={{
                                    width: '14px',
                                    marginRight: 5,
                                    fontSize: '16px',
                                    fontWeight: 700,
                                  }}
                                />{' '}
                                取引先番号
                              </label>
                              <Form.Item name="facility_code">
                                <Input
                                  size={'large'}
                                  value={searchValue.facility_code}
                                  onChange={(e) =>
                                    setSearchValue((oldState) => ({ ...oldState, facility_code: e.target.value }))
                                  }
                                  name="facility_code"
                                  style={{ width: 228 }}
                                  id="search-stk"
                                />
                              </Form.Item>
                              <label className="label-input standardBoldFont" htmlFor="search-cs">
                                <MedicineBoxOutlined style={{ marginRight: 5 }} /> 医療機関名
                              </label>
                              <Form.Item name="facility_name">
                                <Input
                                  name="facility_name"
                                  value={searchValue.facility_name}
                                  onChange={(e) =>
                                    setSearchValue((oldState) => ({ ...oldState, facility_name: e.target.value }))
                                  }
                                  id="search-cs"
                                  size={'large'}
                                  style={{ width: 228 }}
                                />
                              </Form.Item>
                              <Form.Item name="btn-back">
                                <Button
                                  htmlType="reset"
                                  onClick={handleReset}
                                  className="btn-backSetup standardBoldFont"
                                  size={'large'}
                                >
                                  リセット
                                </Button>
                              </Form.Item>
                              <Form.Item name="btn-narrow-down-display">
                                <Button
                                  htmlType="submit"
                                  className="btn-narrow-down-display standardBoldFont"
                                  size={'large'}
                                >
                                  絞り込み表示
                                </Button>
                              </Form.Item>
                              <Col style={{ display: 'flex' }} span={24}>
                                <label
                                  style={{ marginLeft: '3rem' }}
                                  className="label-input standardBoldFont"
                                  htmlFor="search-cs"
                                >
                                  入金名
                                </label>
                                <Form.Item name="account_name">
                                  <Input
                                    name="account_name"
                                    value={searchValue.account_name}
                                    onChange={(e) =>
                                      setSearchValue((oldState) => ({ ...oldState, account_name: e.target.value }))
                                    }
                                    id="search-cs"
                                    size={'large'}
                                    style={{ width: 228 }}
                                  />
                                </Form.Item>
                              </Col>
                            </Form>
                          </Row>
                        </Form>
                      )}
                    />
                  </Row>
                  <Row>
                    <Col span={23}>
                      <Pagination
                        page={page}
                        per_page={20}
                        totalItems={itemInvoices.totalItems}
                        onChangePage={onChangePage}
                      />
                    </Col>
                  </Row>
                  <div className="table">
                    <TableDeposit tab="カード" dataSource={itemInvoices.items} afterUpdate={AfterUpdateBill} />
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Spin>
    </Wrap>
  );
};

const month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

export default DepositManagement;
